export const favoriteUnfavoriteSong = async (songVersionId, request) => {
  const csrfToken = document.querySelector('meta[name="csrf-token"]').content
  const requestOptions = {
    method: "POST",
    headers: {
      "X-CSRF-Token": csrfToken,
      "Content-Type": "application/json",
    },
  }
  var route = "/favorites/" + request + "/song_version/" + songVersionId
  const result = await fetch(route, requestOptions)

  // Update the global mm.user object if it exists
  if (window.mm && window.mm.user) {
    if (request === "add") {
      mm.user.favoriteSongVersions[songVersionId] = true
    } else {
      delete mm.user.favoriteSongVersions[songVersionId]
    }
  }

  // Dispatch event so other parts of the app can sync
  window.dispatchEvent(new CustomEvent("favorite-toggled", {
    detail: { songVersionId, request }
  }))

  return result
}
